import mixin from "@/mixin/index.js"
const _shuffle = mixin.methods._shuffle;
export default {
    disclaimer: state => state.disclaimer,
    loading: state => state.loading,
    getCalculatorModel: state => state.calculatorModel,
    alert: state => state.alert,
    user: state => state.user,
    isPremium: state => !!state.user && !!state.user.premiumStatus,
    veterinaryColleges: state => state.veterinaryColleges,
    reference: state => state.reference,
    isDrugsManagement: state => state.isDrugsManagement,
    userSection: state => state.userSection,
    link_redirect: state => state.link_redirect,
    confirmModel: state => state.confirmModel,
    hasDynamicLink: state => state.hasDynamicLink,
    fromLogin: state => state.fromLogin,
    getStepper: state => state.stepper,
    getStepperTotal: state => state.stepperTotal,
    getStepperData: state => state.stepperData,
    getStepperModel: state => state.stepperModel,
    homeAdds: state => state.homeAdds,
    emailConfirmation: state => state.emailConfirmation,
    products: state => state.products,
    purchasesModel: state => state.purchasesModel,
    trends: state => _shuffle(state.trends).slice(0, 10),
}